module.exports = __webpack_public_path__ + "front/img/b44.cf63ee0d.jpg";